import React, { FC } from 'react';
import styled from 'styled-components';
import LoaderCommon from '@minecraft.loader';
import { useTranslation } from '@blocs.i18n';
import { REPORT_TEST_IDS } from 'components/Reports/Reports.mock';

const LoaderContainer = styled.div`
  padding: 1rem;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
`;

const LoaderText = styled.div`
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

const LoaderCommonWrapper = styled.div`
  position: relative;
  height: 2rem;
`;

const Loader: FC = () => {
  const { t } = useTranslation();

  return (
    <LoaderContainer data-testid={REPORT_TEST_IDS.reportLoader}>
      <LoaderText>{t('common:reportLoader.text')}</LoaderText>
      <LoaderCommonWrapper>
        <LoaderCommon />
      </LoaderCommonWrapper>
    </LoaderContainer>
  );
};

export default Loader;
